/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";

import { Paragraph } from "../UI/Typoraphy";
import { mq } from "../responsive";

const Card = styled.div`
  position: relative;
  background-size: cover;
  background-position: center center;
  height: 18rem;

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgb(0, 0, 0);
    background: linear-gradient(
      2deg,
      rgba(0, 0, 0, 0.4) 0%,
      rgba(250, 250, 250, 0) 50%
    );
  }

  ${mq.md} {
    height: 20rem;
  }
`;

const CategoryCard = ({ category }) => {
  const { title, image } = category;
  return (
    <Card css={{ backgroundImage: `url(${image})` }}>
      <Paragraph
        style={{
          position: "absolute",
          bottom: "1rem",
          left: "2rem",
          color: "#ffffff",
          fontWeight: "bold",
          zIndex: 1,
        }}
      >
        {title}
      </Paragraph>
    </Card>
  );
};

export default CategoryCard;
